/*
 * PrivacySettings Messages
 *
 * This contains all the text for the PrivacySettings component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    curriculumManager: {
        id: 'curriculum-manager.container.curriculumManager',
        defaultMessage: 'Curriculum Manager'
    },
    masterCourses: {
        id: 'curriculum-manager.container.masterCourses',
        defaultMessage: 'Master Courses'
    },
    curriculums: {
        id: 'curriculum-manager.container.curriculums',
        defaultMessage: 'Curriculums'
    },
    curriculumDocuments: {
        id: 'curriculum-manager.container.curriculumDocuments',
        defaultMessage: 'Curriculum alignment documents'
    }
});



// WEBPACK FOOTER //
// ./app/containers/curriculum-manager/messages.js